<template>
  <el-cascader
    v-model="areaCode"
    :options="areas"
    ref="areaSelect"
    style="width: 100%;"
    clearable
    :placeholder="placeholder"
    value = "value"
    :change-on-select="changeOnSelect"
    :filterable="true"
    :show-all-levels="true"
    @change="handleItemChange"
    :props="props"
  ></el-cascader>
  <!-- /.navbar-static-side -->
</template>

<script>
let provinces = require('../framework/data/area.json');
export default {
  name: 'district-and-county-cascader',
  data: function (){
    return {
      areas:provinces,
      props: {
        label: 'name',
        value: 'areaCode',
        children: 'areas'
      },
      cityPosition: null,
      countyPosition: null,
      areaCode: []
    }
  },
  props: {
    dataAlias: {
      type: Array,
      default: function(){
        return []
      }
    },
    changeOnSelect: {
      type: Boolean,
      default: false
    },
    placeholder:{
      type: String,
      default: function () {
        return '请选择'
      }
    },
    defaultAreaCode: {
      type: String,
      default: function (){
        return null
      }
    }
  },
  watch:  {
    defaultAreaCode: function(value) {
      this.setAreaCode(value)
    }
  },
  model: {
    prop: 'defaultAreaCode',
    event: 'change'
  },
  mounted: function () {
    let areaCode = this.getDefaultAreaCode()
    if(areaCode){
      this.areaCode = areaCode
    }
  },
  methods: {
    setAreaCode: function (areaCodeStr){

      if(!areaCodeStr){
          return
      }

      let areaCodes = areaCodeStr.split(',')
      let length = areaCodes.length
      let count = length-4
      let tempStr = ''
      let newAreaCode = []
      for (var j = 0; j < count; j++) {
        for (var i = 0; i < length; i++) {
          let areaCode =  areaCodes[i]

          if(i == length-1){
            tempStr += areaCode
            newAreaCode.unshift(tempStr)
            tempStr = ''
            length--
          }else{
            tempStr += areaCode+','
          }
        }
      }

      this.areaCode = newAreaCode
    },
    handleItemChange: function (newValue) {

      let areaSelect= this.$refs['areaSelect']
      this.$emit('onAreaChanged',newValue,areaSelect.currentLabels)


      //给form模版使用
      if(this.dataAlias&&this.dataAlias.length==2){
        let areaData = {}
        areaData[this.dataAlias[0]] = newValue[newValue.length-1]//areaCode
        areaData[this.dataAlias[1]] = areaSelect.currentLabels.join(' ') //选择的地址

        this.$emit('onChanged',areaData)
      }


      // for (var i = 0; i < newValue.length; i++) {
      //   let value = newValue[i]
      //   if(this.dataAlias.length>i){
      //     areaData[this.dataAlias[i]] = value
      //     // newData.push({
      //     //   name: this.dataAlias[i],
      //     //   value: value
      //     // })
      //   }else{
      //     newData.push({
      //       name: null,
      //       value: value
      //     })
      //   }
      // }


    },
    resetData: function () {

      this.areaCode = []
    },
    clear: function () {
      this.areaCode = []
    },
    getDefaultAreaCode: function () {
      if(!this.defaultAreaCode){
        return
      }

      let codes = this.defaultAreaCode.split(',')
      let codeLength = codes.length
      let subLength = 3

      if(codeLength==7){
        subLength = 3
      } else {
        subLength = 2
      }

      let areaCode = []
      for (let i = subLength; i > 0; i--) {
        let codeStr = ''
        for (let j = 0; j < codeLength; j++) {
          codeStr += codes[j]

          let index = codeLength-i;
          if(j==index){
            break
          }

          codeStr+=','

        }

        areaCode.push(codeStr)
      }

       return areaCode
    }
  }
}
</script>
